import { render, staticRenderFns } from "./workerAdd1Wx.vue?vue&type=template&id=7539ba7f&scoped=true&"
import script from "./workerAdd1Wx.vue?vue&type=script&lang=js&"
export * from "./workerAdd1Wx.vue?vue&type=script&lang=js&"
import style0 from "./workerAdd1Wx.vue?vue&type=style&index=0&id=7539ba7f&scoped=true&lang=css&"
import style1 from "./workerAdd1Wx.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7539ba7f",
  null
  
)

export default component.exports